import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { RouterModule } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { BillingService } from "../../services/billing.service";
import { getPaymentProductName, IPayment } from "../../model/payment.model";
import { TranslocoCurrencyPipe, TranslocoDatePipe } from "@jsverse/transloco-locale";

@Component({
    selector: 'clp-billing-thumb',
    styleUrls: ['./billing-thumb.component.scss'],
    templateUrl: './billing-thumb.component.html',
    imports: [
        RouterModule,
        TranslateModule,
        CommonModule,
        TranslocoDatePipe,
        TranslocoCurrencyPipe
    ],
    providers: [
        BillingService,
        ToastrService
    ]
})

export class BillingThumbComponent {
    @Input() payment!: IPayment | null;

    getProductName(payment: IPayment | null | undefined): string {
        return getPaymentProductName(payment) || '-';
    }

    getPaymentText(status: string | null | undefined): string {
        return `financials.paymentStatus.${this.getCanonicalStatus(status)}`;
    }

    getStatusClass(status: string | null | undefined): string {
        const canonicalStatus = this.getCanonicalStatus(status);

        if (canonicalStatus === 'paid' || canonicalStatus === 'active') {
            return 'payment-status-success';
        }

        if (canonicalStatus === 'cancelled' || canonicalStatus === 'refunded') {
            return 'payment-status-neutral';
        }

        if (canonicalStatus === 'rejected' || canonicalStatus === 'failed' || canonicalStatus === 'unpaid') {
            return 'payment-status-danger';
        }

        if (canonicalStatus === 'pending') {
            return 'payment-status-pending';
        }

        return 'payment-status-unknown';
    }

    private getCanonicalStatus(status: string | null | undefined): string {
        const normalizedStatus = this.normalizeStatus(status);

        switch (normalizedStatus) {
            case 'active':
            case 'trialing':
                return 'active';

            case 'paid':
            case 'succeeded':
            case 'captured':
            case 'complete':
            case 'completed':
            case 'authorized':
            case 'approved':
                return 'paid';

            case 'cancelled':
            case 'canceled':
            case 'void':
            case 'voided':
            case 'expired':
                return 'cancelled';

            case 'rejected':
            case 'declined':
            case 'paymentrejected':
                return 'rejected';

            case 'failed':
            case 'failure':
            case 'error':
                return 'failed';

            case 'unpaid':
            case 'pastdue':
            case 'overdue':
                return 'unpaid';

            case 'refunded':
            case 'refund':
                return 'refunded';

            case 'pending':
            case 'processing':
            case 'inprogress':
            case 'requiresaction':
            case 'requirescapture':
            case 'requirespaymentmethod':
            case 'open':
                return 'pending';

            default:
                return 'unknown';
        }
    }

    private normalizeStatus(status: string | null | undefined): string {
        if (!status) {
            return '';
        }

        return status.trim().toLowerCase().replace(/[\s_-]+/g, '');
    }
}
